<form class="boels-place-order-form" [formGroup]="reviewRentalConditionForm()">
  <div class="form-group additional-remarks">
    <label>
      <boels-textarea
        [maxlength]="remarkInputLimit"
        [label]="'checkout.review.remarks' | transloco"
        [showDivider]="true"
        [formControl]="$any(reviewRentalConditionForm().get('remarks'))"
        class="form-control"
        formControlName="remarks"
        rows="4"
        cols="50"
      >
      </boels-textarea>
    </label>
  </div>
  <div class="form-group newsletter">
    <label class="form-check">
      <input
        formControlName="newsletter"
        class="form-check-input"
        type="checkbox"
      />
      <span class="form-check-label">
        {{ 'checkout.review.newsletterPrefix' | transloco }}
        <a
          [cmsRouterLink]="'/privacy-statement'"
          class="boels-tc-link"
          target="_blank"
        >
          {{ 'checkout.review.newsletterLink' | transloco }}
        </a>
        {{ 'checkout.review.newsletterSuffix' | transloco }}
      </span>
    </label>
  </div>
  <div class="form-group rentalConditions">
    <label class="form-check">
      <input
        formControlName="termsAndConditions"
        class="form-check-input"
        type="checkbox"
      />
      <span class="form-check-label">
        {{ 'checkout.review.rentalConditionsPrefix' | transloco }}
        <a
          [cmsRouterLink]="'/rental-conditions'"
          class="boels-tc-link"
          target="_blank"
        >
          {{ 'checkout.review.rentalConditionsLink' | transloco }}
        </a>
        {{ 'checkout.review.rentalConditionsSuffix' | transloco }}
      </span>
      <boels-form-errors
        [control]="reviewRentalConditionForm().get('termsAndConditions')"
      ></boels-form-errors>
    </label>
  </div>
</form>
